import { Logger, rollbarTransport } from "@sunrun/sales-experience-shared";
import { rollbar } from "./rollbar";

const logger = new Logger({
  runtime: "web",
  application: "SalesExp",
  transports: [
    rollbarTransport(rollbar as Parameters<typeof rollbarTransport>[0]),
  ],
});

export { logger };
